__turbopack_context__.v({
  "body": "LSF7Fa_body",
  "card": "LSF7Fa_card",
  "date": "LSF7Fa_date",
  "imageBadge": "LSF7Fa_imageBadge",
  "imageWrap": "LSF7Fa_imageWrap",
  "imageWrapMuted": "LSF7Fa_imageWrapMuted",
  "link": "LSF7Fa_link",
  "poster": "LSF7Fa_poster",
  "price": "LSF7Fa_price",
  "stickerBottomLeft": "LSF7Fa_stickerBottomLeft",
  "tagTopLeft": "LSF7Fa_tagTopLeft",
  "tagTopRight": "LSF7Fa_tagTopRight",
  "title": "LSF7Fa_title",
  "venue": "LSF7Fa_venue",
});
